import React, { useEffect, useState, useRef } from "react"
import get from "lodash/get"
import { API_URL } from "../../../../constants/constants"
import { getAllRiskManagementSetting } from "store/riskManagement/actions"
import axios from "axios"

import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Label,
  Input,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import {
  getTokenFromLocalStorage,
  showErrorMessages,
  hasPermission,
} from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { useSelector, useDispatch } from "react-redux"
import { setRegulatory } from "helpers/repository"

export default function Regulatory(props) {
  const dispatch = useDispatch()

  const [sales_excise_tax, setSalesExciseTax] = useState("")
  const [wht_winning_tax, setWHTWinningTax] = useState("")
  const [wht_winning_tax_apply_over, setWHTTaxApplyOver] = useState("")
  const [betting_tax, setBettingTax] = useState("")
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    setSalesExciseTax(get(props, "data.sales_excise_tax", ""))
    setWHTWinningTax(get(props, "data.wht_winning_tax", ""))
    setWHTTaxApplyOver(get(props, "data.wht_winning_tax_apply_over", ""))
    setBettingTax(get(props, "data.betting_tax", ""))
  }, [])

  const toggle = () => {
    setIsOpen(!isOpen)
  }

  const handleClick = () => {
    toggle()
  }

  const handleSubmit = e => {
    e.preventDefault()
    setRegulatory({
      sales_excise_tax: sales_excise_tax,
      wht_winning_tax: wht_winning_tax,
      wht_winning_tax_apply_over: wht_winning_tax_apply_over,
      betting_tax: betting_tax,
    })
      .then(function (response) {
        //handle success
        showMessage("success", response.data.message)
        dispatch(getAllRiskManagementSetting())
        toggle()
      })
      .catch(function (response) {
        showErrorMessages(response)
      })
  }
  return (
    <React.Fragment>
      <Col>
        <Card>
          <CardBody>
            <CardTitle className="mb-4">Regulatory</CardTitle>

            <Form>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Sales Excise Tax</Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.sales_excise_tax", "")}
                  </p>
                </Col>
              </div>

              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">WHT/Winnings Tax</Label>
                </Col>
                <Col xs={6} sm={8} md={8} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.wht_winning_tax", "")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">
                    WHT/Winning Tax Apply over
                  </Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.wht_winning_tax_apply_over", "")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4">
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Betting Tax</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">
                    {get(props, "data.betting_tax", "")}
                  </p>
                </Col>
              </div>
              <div className="row mb-4" style={{ visibility: "hidden" }}>
                <Col xs={6} sm={4} md={4} lg={6}>
                  <Label className="col-form-label">Betting Tax</Label>
                </Col>
                <Col xs={6} sm={8} md={6} lg={6}>
                  <p className="text-muted fw-medium col-form-label">10%</p>
                </Col>
              </div>

              {hasPermission("update-parameters") && (
                <div className="d-flex flex-wrap gap-2">
                  <Button
                    type="button"
                    color="primary"
                    className=""
                    onClick={handleClick}
                  >
                    Edit
                  </Button>
                </div>
              )}
            </Form>
          </CardBody>
        </Card>
      </Col>
      <Modal centered isOpen={isOpen} toggle={toggle}>
        <ModalHeader tag="h4" toggle={toggle}>
          {"Update Regulatory Details"}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <div className="mb-3">
              <Label htmlFor="horizontal-sales-excise-tax-Input">
                Sales Excise Tax
              </Label>
              <Input
                type="text"
                className="form-control"
                id="horizontal-sales-excise-tax-Input"
                name={"exciseTax"}
                value={sales_excise_tax}
                required
                onChange={e => {
                  setSalesExciseTax(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="horizontal-wht-winning-tax-Input">
                WHT/Winnings Tax
              </Label>
              <Input
                type="text"
                className="form-control"
                id="horizontal-wht-winning-tax-Input"
                name={"WHTax"}
                value={wht_winning_tax}
                required
                onChange={e => {
                  setWHTWinningTax(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="horizontal-wht-winning-tax-apply-over-Input">
                WHT/Winning Tax Apply over
              </Label>
              <Input
                type="text"
                className="form-control"
                id="horizontal-wht-winning-tax-apply-over-Input"
                name={"WHTaxApplyOver"}
                value={wht_winning_tax_apply_over}
                required
                onChange={e => {
                  setWHTTaxApplyOver(e.target.value)
                }}
              />
            </div>

            <div className="mb-3">
              <Label htmlFor="horizontal-betting-tax-Input">Betting Tax</Label>
              <Input
                type="text"
                className="form-control"
                id="horizontal-betting-tax-Input"
                name={"WHTax"}
                value={betting_tax}
                required
                onChange={e => {
                  setBettingTax(e.target.value)
                }}
              />
            </div>

            <div className="text-end">
              <Button type="submit" className="btn btn-success w-md">
                Save
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}
